import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { uiKitScope } from '../../constants/ui-constant';
import { KeeniconComponent } from '../../partials';
import { CustomTooltipDirective } from '@core-utils';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-button',
  imports: [
    NgClass,
    TranslocoDirective,
    KeeniconComponent,
    CustomTooltipDirective,
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
  host: {
    '[attr.data-cy]': 'dataCy() || null',
    '[class.disabled]': 'disabled()',
  },
})
export class ButtonComponent {
  protected readonly uiKitScope = uiKitScope;
  dataCy = input<string>('');
  btnClass = input<string>('');
  buttonText = input<string>('');
  tooltipText = input<string>('');
  iconClass = input<string>('fs-4');
  icon = input<string>('');
  counter = input<number>(0);
  outline = input<boolean>(false);
  isLoading = input<boolean>(false);
  disabled = input<boolean>(false);
  severity = input<string>('primary');
  size = input<string>('md');
  href = input<string>('');

  handleClick(event: MouseEvent) {
    event.preventDefault();
    if (this.href()) {
      window.open(this.href(), '_blank');
    }
  }
}
